var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTestingEndpointIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.333984,
    y: 0.333496,
    width: 13.3333,
    height: 13.3333,
    rx: 6.66667,
    fill: "#F6851B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.10156 10.2C6.10156 9.75817 6.45974 9.4 6.90156 9.4H7.10156C7.54339 9.4 7.90156 9.75817 7.90156 10.2C7.90156 10.6418 7.54339 11 7.10156 11H6.90156C6.45974 11 6.10156 10.6418 6.10156 10.2ZM6.10156 3.9C6.10156 3.40294 6.50451 3 7.00156 3C7.49862 3 7.90156 3.40294 7.90156 3.9V6.9C7.90156 7.39706 7.49862 7.8 7.00156 7.8C6.50451 7.8 6.10156 7.39706 6.10156 6.9V3.9Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestingEndpointIcon);
export default __webpack_public_path__ + "static/media/TestingEndpointIcon.d496a3ba50b53c5c7e454e80d5ea36d5.svg";
export { ForwardRef as ReactComponent };